import { StylingModel } from '../style/styling.model';
import { CoreStylingModel } from '../core/core-styling.model';
import { ButtonStylingModel } from '../button/button-styling.model';
export class FormGroupStylingModel extends CoreStylingModel {
/**
 * Styling for the group title
 */
title?: StylingModel;
/**
 * Styling for the form content
 */
content?: StylingModel;
/**
 * Styling for the form submit section
 */
submitSection?: StylingModel;
/**
 * Styling for submit button
 */
submitButton?: ButtonStylingModel;
/**
 * @hidden
 * @param {?=} values
 */
constructor(values: Object = {}) {
    super(values);
    Object.assign(this, values);
  }
}

function FormGroupStylingModel_tsickle_Closure_declarations() {
/**
 * Styling for the group title
 * @type {?}
 */
FormGroupStylingModel.prototype.title;
/**
 * Styling for the form content
 * @type {?}
 */
FormGroupStylingModel.prototype.content;
/**
 * Styling for the form submit section
 * @type {?}
 */
FormGroupStylingModel.prototype.submitSection;
/**
 * Styling for submit button
 * @type {?}
 */
FormGroupStylingModel.prototype.submitButton;
}

